import { TabItem } from "../../components/TabItem";
import * as Tabs from "@radix-ui/react-tabs";
import * as ScrollArea from "@radix-ui/react-scroll-area";
import { ListEventos } from "./ListEventos";
import { CreateEvent } from "./CreateEvent";
import { useStore } from "../../store";
import { CertificadoLoteAdmin } from "../../components/certificado-lote-admin";
import { useTabContext } from ".";

export function EventosTabs() {
  const { currentTab, setCurrentTab } = useTabContext();
  const user = useStore((state) => state.user);

  return (
    <Tabs.Root value={currentTab} onValueChange={setCurrentTab}>
      <ScrollArea.Root className="w-full" type="hover">
        <ScrollArea.Viewport className="w-full overflow-x-scroll">
          <Tabs.List className="mt-4 flex w-full items-center gap-1 sm:gap-4 border-b border-zinc-200/90 dark:border-zinc-800">
            <TabItem
              isSelected={currentTab === "tab1"}
              value="tab1"
              title="Eventos"
              onClick={() => setCurrentTab("tab1")}
            />
            {(user.user_type === "ADMIN" ||
              user.user_type === "SUPERADMIN") && (
              <TabItem
                isSelected={currentTab === "tab2"}
                value="tab2"
                title="Novo Evento"
                onClick={() => setCurrentTab("tab2")}
              />
            )}
            {(user.user_type === "ADMIN" ||
              user.user_type === "SUPERADMIN") && (
              <TabItem
                isSelected={currentTab === "tab3"}
                value="tab3"
                title="Certificados em lote"
                onClick={() => setCurrentTab("tab3")}
              />
            )}
          </Tabs.List>
        </ScrollArea.Viewport>
        <ScrollArea.Scrollbar
          className="flex h-2.5 touch-none select-none flex-col bg-zinc-100 p-0.5"
          orientation="horizontal"
        >
          <ScrollArea.Thumb className="relative flex-1 rounded-lg bg-zinc-300 before:absolute before:left-1/2 before:top-1/2 before:h-full before:min-h-[44px] before:w-full before:min-w-[44px] before:-translate-x-1/2 before:-translate-y-1/2 before:content-['']" />
        </ScrollArea.Scrollbar>
      </ScrollArea.Root>

      <Tabs.Content value="tab1">
        <ListEventos />
      </Tabs.Content>

      <Tabs.Content value="tab2">
        <CreateEvent />
      </Tabs.Content>

      {(user.user_type === "ADMIN" || user.user_type === "SUPERADMIN") && (
        <Tabs.Content value="tab3">
          <CertificadoLoteAdmin />
        </Tabs.Content>
      )}
    </Tabs.Root>
  );
}
